<!--Desktop view-->
<div>
  <mat-toolbar
    class="nav-main"
    [ngClass]="{
      'width-fix': deviceService.isLargeScreen()
    }"
  >
    <button
      *ngIf="!deviceService.isLargeScreen()"
      (click)="navigationService.toggle()"
      [ngClass]="{ hidden: navigationService.opened }"
      mat-icon-button
      aria-label="Example icon-button with share icon"
      test-filter="nav"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <!--Slalom logo-->
    <a routerLink="./" [ngClass]="{ hidden: navigationService.opened }">
      <svg fxHide [fxShow.gt-sm]="true" viewBox="0 0 97.73 16.02" class="me-slalom-logo-svg">
        <use xlink:href="assets/me-logo-small.svg#me-slalom-logo"></use>
      </svg>
      <svg fxShow [fxHide.gt-sm]="true" viewBox="0 0 97.73 16.02" class="m-at-s-logo-svg">
        <use xlink:href="assets/m_at_s_logo.svg#me-slalom-logo"></use>
      </svg>
    </a>

    <span class="flex-fill"></span>

    <!--Search-->
    <div fxLayout="row" fxHide [fxShow.gt-md]="true">
      <app-common-search [(searchActive)]="searchActive"></app-common-search>
      <button mat-button color="primary" class="advanced-search-button" routerLink="/search">
        Advanced Search
      </button>
    </div>

    <!--Mobile search-->
    <span
      fxHide
      [fxShow.lt-lg]="true"
      aria-label="Search"
      [ngClass]="{ expanded: searchActive }"
      (click)="toggleSearch()"
      class="material-symbols-outlined"
      >search</span
    >

    <!--Notification icon-->
    <app-notification-menu
      *ngIf="showNotifications"
      [notifications]="notifications"
    ></app-notification-menu>

    <!--Profile picture icon-->
    <app-common-lazyloader
      fxHide
      [fxShow.gt-sm]="true"
      Cwidth="46"
      Cheight="46"
      circle="true"
      *ngIf="!user?.name"
    ></app-common-lazyloader>
    <div
      fxHide
      [fxShow.gt-sm]="true"
      [matMenuTriggerFor]="menu"
      class="bio-avatar bio-avatar-small grow"
      [ngStyle]="{
        'background-image': 'url(' + user?.photo + ')'
      }"
      *ngIf="user?.name"
    >
      <div *ngIf="!user?.photo" class="initials">
        {{ user?.name | initials }}
      </div>
    </div>

    <!--Right menu contents-->
    <mat-menu class="main-nav-desktop" #menu="matMenu">
      <button mat-menu-item>
        <app-small-bio *ngIf="user" [employee]="user" [inline]="true"></app-small-bio>
      </button>
      <div class="menu-separator"></div>
      <button mat-menu-item>
        <a
          class="feedback-link"
          target="_blank"
          href="https://slalom.service-now.com/help?id=emp_taxonomy_topic&topic_id=2585772247cf9610ff13d88b416d4392"
        >
          Submit me&#64;slalom Feedback</a
        >
      </button>
      <button mat-menu-item [matMenuTriggerFor]="themes">Themes</button>
      <button *ngIf="showPersonas" mat-menu-item [matMenuTriggerFor]="personas">
        Impersonation
      </button>
    </mat-menu>

    <mat-menu #themes="matMenu">
      <button
        *ngFor="let colorTheme of colorThemes"
        [ngClass]="{ 'current-selection': theme === colorTheme.themeId }"
        class="theme-buttons"
        [disabled]="theme === colorTheme.themeId"
        (click)="updateTheme($event, colorTheme.themeId)"
        mat-menu-item
      >
        <app-common-graphic
          [theme]="colorTheme.themeId"
          [graphicId]="'theme-preview'"
        ></app-common-graphic
        ><span class="label">{{ colorTheme.label }}</span>
      </button>
    </mat-menu>

    <mat-menu #personas="matMenu">
      <button
        [disabled]="persona.employeeId === user?.employeeId"
        [ngClass]="{
          'current-selection': persona.employeeId === user?.employeeId
        }"
        class="persona-button"
        (click)="setPersona(persona.employeeId)"
        *ngFor="let persona of selectablePersonas"
        mat-menu-item
      >
        <app-small-bio
          [employee]="persona"
          [subtitle]="persona.personaTitle"
          [inline]="true"
          [linkToProfile]="false"
        ></app-small-bio>
      </button>
      <button
        *ngIf="user?.employeeId.includes('P')"
        (click)="setPersona(null)"
        class="clear-button"
        mat-menu-item
      >
        Clear impersonation
      </button>
    </mat-menu>

    <div fxShow [fxHide.gt-sm]="true">
      <!--Right menu button-->
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Site menu" class="more-dot">
        <mat-icon>more_vert</mat-icon>
      </button>
      <!--Left menu contents-->
      <mat-menu class="main-nav-mobile" #menu="matMenu">
        <button routerLink="/" routerLinkActive="active" class="btn-large" mat-button>
          Dashboard
        </button>
        <button routerLink="/titles" routerLinkActive="active" class="btn-large" mat-button>
          Job Titles
        </button>
        <button
          routerLink="/roles/role-libray"
          routerLinkActive="active"
          class="btn-large"
          mat-button
        >
          Roles
        </button>
      </mat-menu>
    </div>
  </mat-toolbar>
</div>

<!--Drop down search menu contents-->
<mat-accordion (opened)="searchActive = true" (closed)="searchActive = false">
  <mat-panel-description class="search-menu-content">
    <div class="search-menu-content" fxLayout="column">
      <button
        fxHide
        [fxShow.lt-lg]="searchActive"
        mat-button
        color="primary"
        class="advanced-search-button"
        routerLink="/advanced-search"
        (click)="closeSearch()"
      >
        Advanced Search
      </button>
      <app-common-search
        fxHide
        [fxShow.lt-lg]="searchActive"
        [(searchActive)]="searchActive"
      ></app-common-search>
    </div>
  </mat-panel-description>
</mat-accordion>

<button id="tooltip-placeholder" matTooltip="test"></button>
